import {Component, Input} from '@angular/core';
import {ButtonColor} from "./button-color";
import {IconFont} from "../../enums/icon-font";

@Component({
  selector: 'brt-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input('title') title = "";
  @Input('before-icon') beforeIcon!: IconFont;
  @Input('after-icon') afterIcon!: IconFont;
  @Input('color') set setColor(val: ButtonColor) {
    this.color = val;
  }
  @Input('show-loader') showLoader = false;

  @Input('size') size: 'small' | 'normal' | 'large' | 'x-large' = 'normal';
  @Input('disabled') disabled = false;
  @Input('wide') wide = false;
  @Input('add-blur') addBlur = false;

  @Input('type') type: "button" | "link" = "button";

  color: ButtonColor = "river";


}
